import React from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button } from "semantic-ui-react";
import { newStat } from "../../../store/actions/statsPhotosAction";
import Card from "./Card";
import "./StatsPhotos.css";

const StatsPhotos = (props) => {
  const dispatch = useDispatch();
  const handleButtonChange = (file) => {
    if (file.type.startsWith("image/")) {
      dispatch(newStat(file, props.id));
    }
  };
  return (
    <div className="AdminAthleteActionImagesContainer">
      <div className="AdminAthleteActionImagesTitleButtonContainer">
        <h3>Stats/Measurables</h3>
        <div className="position-relative">
          {!props.adding && !props.error && (
            <input
              id="statPhotos"
              type="file"
              accept="image/*"
              onChange={(e) => {
                handleButtonChange(e.target.files[0]);
              }}
            />
          )}
          <Button
            loading={props.adding}
            positive={props.add}
            negative={props.error}
            floated="right"
            name="addPhotosHighSchoolButton"
            content="Add Photos"
            labelPosition="right"
            icon="image"
          />
        </div>
      </div>
      {props.stats && props.stats.length > 0 && (
        <div className="AdminAthleteActionImages">
          {props.stats.map((stat, index) => (
            <Card stat={stat} id={props.id} key={index + 1} />
          ))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const statsData = state.firestore.data.athletesStats;
  const id = ownProps.id;
  let stats = [];
  if (statsData && id && Object.keys(statsData).length > 0) {
    if (
      statsData[id] &&
      Object.keys(statsData[id]).length > 0 &&
      statsData[id].stats &&
      statsData[id].stats.length > 0
    ) {
      stats = statsData[id].stats;
    }
  }

  return {
    stats,
    auth: state.firebase.auth,
    add: state.statsPhotos.Add,
    adding: state.statsPhotos.Adding,
    error: state.statsPhotos.AddError,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "athletesStats",
    },
  ])
)(StatsPhotos);
